import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

import { AuthSubmitIcon } from './AuthSubmitIcon';
import { authSubmitButtonClassName } from './authStyles';

type AuthSubmitButtonProps = React.ComponentProps<typeof Button>;

export function AuthSubmitButton({
  className,
  children,
  ...props
}: AuthSubmitButtonProps) {
  return (
    <Button
      className={cn(
        'h-[50px] gap-2 bg-brand-primary font-label uppercase text-white hover:bg-brand-primary-dark',
        authSubmitButtonClassName,
        className,
      )}
      {...props}
    >
      <AuthSubmitIcon />
      {children}
    </Button>
  );
}
